import React from 'react';
import { AREAS } from '../constants';

const relTime = (iso, locale) => {
  if (!iso) return null;
  const d = new Date(iso);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
};

// Areas that feel alive: context, not only statistics.
export default function AreaTiles({ areas = {}, t, locale, onOpen }) {
  return (
    <section className="crs-areas" data-testid="creator-area-tiles">
      <p className="crs-section__label">{t.cr_areas || 'Areas'}</p>
      <p className="crs-areas__intro" data-testid="creator-areas-intro">
        {t.cr_areas_intro || 'Dedicated spaces for every part of your life and work.'}
      </p>
      <div className="crs-areas__grid">
        {AREAS.map(({ key, name, icon: Icon, inbox }) => {
          const m = areas[key] || {};
          const when = relTime(m.last_at, locale);
          return (
            <button
              key={key}
              type="button"
              className={`crs-tile${inbox ? ' is-inbox' : ''}`}
              data-testid={`creator-area-${key}`}
              onClick={() => onOpen(key)}
              title={t[`cr_area_desc_${key}`] || ''}
            >
              <span className="crs-tile__head">
                <Icon size={16} strokeWidth={1.3} />
                <span className="crs-tile__name">{name}</span>
              </span>
              <span className="crs-tile__meta">
                {m.open || 0} {t.cr_open_entries || 'open entries'}
                {(m.projects || 0) > 0 && ` \u00b7 ${m.projects} ${t.cr_active_projects || 'projects'}`}
              </span>
              {when && (
                <span className="crs-tile__when">{t.cr_last_edited || 'Last edited'}: {when}</span>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
}
